//引入
import request from "../utils/request";
import wyqyId from "../config";
const api = {
    // 1  
    sqxqwgList: function (query) {
        let params = {
            wyqyId: wyqyId,
            ...query
        };
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/shzzryonelist",
        });
    },

    // 3  
    sqxqwgList2: function (query) {
        let params = {
            wyqyId: wyqyId,
            ...query
        };
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/zzrylist",
        });
    },

    // N   
    shzzlist: function (query) {
        let params = {
            wyqyId: wyqyId,
            ...query
        };
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwybzhjs/shzzlist",
        });
    },



};

export default api;
